import { render } from "./Copy.vue?vue&type=template&id=e5f01172&scoped=true&ts=true"
import script from "./Copy.vue?vue&type=script&lang=ts"
export * from "./Copy.vue?vue&type=script&lang=ts"

import "./Copy.vue?vue&type=style&index=0&id=e5f01172&scoped=true&lang=css"

import exportComponent from "E:\\01.Progetti\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5f01172"]])

export default __exports__